import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ProductTypeState = readonly string[];

export const PRODUCT_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ProductTypeState>>,
): ConditionType<ProductTypeState, Condition.ProductType> => ({
  name: "Product type",
  description(state) {
    return `Product type: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<ProductTypeState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.ProductType) {
    return model.productTypes;
  },
  toModel(state) {
    return { type: Condition.PRODUCT_TYPE, productTypes: state };
  },
  valid() {
    return true;
  },
});
